import { Form, Image, Popup, Toast } from "antd-mobile";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import {
  CustomBottomButton,
  CustomCard,
  CustomDialog,
  CustomNavBar,
  CustomTextArea,
} from "../../../../components";
import { envChangeType } from "../../../../plugins/utils";
import { useApplyPromotion } from "../../hooks/event.hook";
import styles from "./style.module.scss";
import "./style.scss";

function EventDetailPopup(props) {
  const { t } = useTranslation();
  const { detailItem } = props;
  const handler = useRef();
  const [form] = Form.useForm();
  const { mutate: applyPromotion } = useApplyPromotion();

  return (
    <Popup
      className="custom-drawer-popup"
      {...props}
      position="right"
      bodyStyle={{ width: "100vw", backgroundColor: "var(--main-bg)" }}
    >
      <CustomNavBar onBack={props.onClose}>{detailItem?.title}</CustomNavBar>
      <div
        style={{
          padding: "12px",
          height: "calc(100vh - 45px)",
          overflowY: "scroll",
          paddingBottom: "60px",
        }}
        className="event-detail-card"
      >
        <CustomCard>
          <Image
            src={`${envChangeType("REACT_APP_CDN_URL")}/${detailItem?.img_url}`}
            // height={111}
            // style={{
            //   width: "calc(100vw - 24px)",
            //   height: "calc((100vw - 24px) / var(--banner-width-height-ratio))",
            // }}
            fit="cover"
          />
          <div className={styles.eventDetail}>
            <div className={styles.title}>{detailItem?.title}</div>
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: detailItem?.content }}
            />
          </div>
        </CustomCard>
      </div>
      <CustomBottomButton
        onClick={() => {
          handler.current = CustomDialog({
            type: "confirm",
            dialogProps: {
              header: t("personal.agentList.apply"),
              destroyOnClose: true,
              content: (
                <>
                  <Form layout="horizontal" mode="card" form={form} className="custom-modal-form">
                    <CustomTextArea
                      rules={[
                        {
                          required: true,
                          message: t("personal.agentList.apply.contact"),
                        },
                      ]}
                      placeholder={t("event.apply.form.placeholder")}
                      name="apply_content"
                      showCount={true}
                      maxLength={300}
                    />
                  </Form>
                </>
              ),
              onConfirm: async () => {
                await form.validateFields();
                const fileds = {
                  apply_content: form.getFieldValue("apply_content"),
                  id: detailItem.id,
                  trans_id: detailItem.trans_id,
                };
                console.log("fileds", fileds);
                await applyPromotion(
                  {
                    params: fileds,
                  },
                  {
                    onSuccess: () =>
                      Toast.show({
                        icon: "success",
                        content: t("normal.isSent"),
                      }),
                  },
                  {
                    onError: (error) => {
                      Toast.show({
                        icon: "fail",
                        content: error,
                      });
                    },
                  },
                );
              },
              cancelText: <span>{t("normal.cancel")}</span>,
              confirmText: <>{t("normal.apply.confirm")}</>,
              onClose: () => {
                form.resetFields();
              },
            },
          });
        }}
      >
        {t("personal.agentList.apply")}
      </CustomBottomButton>
    </Popup>
  );
}

export default EventDetailPopup;
